import React, { useEffect, useState } from 'react'
import './WallpapersSection.scss'
import WallpaperPost from '../../components/WallpaperPost/WallpaperPost';
import { Link } from 'react-router-dom';

function WallpapersSection(props) {
  const [wallpaper,setWallpaper] = useState();

  useEffect(() => {
    randomWallpaper();
    console.log("Random Wallpaper Function Started");
    setInterval(randomWallpaper,5000);
  },[]);

  function randomWallpaper(){
    
    var wallpaperIndex = Math.floor(Math.random() * props.wallpapers.length)

    const wallpaper =Object.assign({}, props.wallpapers[wallpaperIndex]);  
    setWallpaper(wallpaper);
  }
  
  return (
    <div>
      <div className='wallpaper-section container'>
        <div className='wallpapers'>
          <WallpaperPost wallpaper={wallpaper} />
        </div>
        <div className='wallpapers-button'>
          <Link to={"/wallpapers"}>
            <button>Wallpapers</button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default WallpapersSection